import React from 'react';
import { useTranslation } from 'react-i18next';

function AirStatus({
  data = [],
  emission = [],
  title,
  showLogs = ['T', 'RH', 'CO2'],
  className = 'view_img_pop1',
  emissionCodes = [],
}) {
  const { t } = useTranslation();
  
  if (
    (!Array.isArray(data) || data.length === 0) &&
    (!Array.isArray(emission) || emission.length === 0)
  ) {
    return null;
  }

  // logCode → object 매핑
  const logMap = Object.fromEntries(
    (Array.isArray(data) ? data : []).map(v => [v.logCode, v])
  );

  const emissionMap = Object.fromEntries(
    (Array.isArray(emission) ? emission : []).map(
      v => [v.componentLocationCode, v]
    )
  );

  const header = data?.[0] ?? emission?.[0];

  return (
    <div className={className}>
      <p>
        {title ??
          `${header.componentLocationName} (${header.componentLocationCode})`}
      </p>

      <div className="metrics">
        {showLogs.map(code => {
          const log = logMap[code];
          if (!log) return null;

          return (
            <div key={code}>
              • {log.logName ?? code} : {log.logValue} {log.logUnit}
            </div>
          );
        })}

        {/* 개도율 (단일 or 복수 공통 처리) */}
        {emissionCodes
          .map(code => emissionMap[code])
          .filter(Boolean)
          .length > 0 && (
            <div>
              • {emissionMap[emissionCodes[0]]?.logName ??
                `${t('message.common.subtitle.opening.rate')}`} :
              {emissionCodes
                .map(code => emissionMap[code])
                .filter(Boolean)
                .map((v, i) => (
                  <span key={v.componentLocationCode}>
                    {i === 0 ? ' ' : ' / '}
                    {v.logValue} {v.logUnit}
                  </span>
                ))}
            </div>
          )}
      </div>
    </div>
  );
}

export default AirStatus;
